import { render, staticRenderFns } from "./admin-table-search.vue?vue&type=template&id=37d490fc&"
import script from "./admin-table-search.vue?vue&type=script&lang=js&"
export * from "./admin-table-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports